import { render, staticRenderFns } from "./00_UeberUns.vue?vue&type=template&id=1b861cde&"
import script from "./00_UeberUns.vue?vue&type=script&lang=js&"
export * from "./00_UeberUns.vue?vue&type=script&lang=js&"
import style0 from "./00_UeberUns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports